import React from 'react'
import { Link } from 'react-router-dom';
const Navbar = () => {
    function openNav() {
        document.getElementById("mySidenav").style.width = "28rem";
        document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
        document.getElementById("hamburger").style.display = "none";
      }
    return (
        <>
            <nav className="navigation">
                <Link className="link" to="/">
                    <div className="brand-name">
                        <img className="img-logo" src="/images/logo.png" />
                        <span className="navbrand">Foam UI</span>
                    </div>
                </Link>
                <span id="hamburger" className="hamburger pointer" onClick={()=>openNav()}>&#9776;</span>
            </nav>
        </>
    )
}

export default Navbar
